var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('oa-page',{staticClass:"pb-8",attrs:{"slug":"home"}}),_c('oa-posts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }